import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import CurrencyConverter from '../CurrencyConverter';
import messages from '../../locale/messages';
import { getBillingDetails } from '../../helpers/Pricing/getBillingDetails.js';
import s from './Payment.css';

class PaymentDetails extends Component {
	static propTypes = {
		checkIn: PropTypes.string.isRequired,
		checkOut: PropTypes.string.isRequired,
		total: PropTypes.number.isRequired,
		basePrice: PropTypes.number.isRequired,
		cleaningPrice: PropTypes.number.isRequired,
		serviceFee: PropTypes.number.isRequired,
		currency: PropTypes.string.isRequired,
		formatMessage: PropTypes.any,
	};

	render() {
		const { checkIn, checkOut, basePrice, cleaningPrice, total, bookingSpecialPricing, discount, discountType, tax } = this.props;
		const { serviceFee, currency } = this.props;
		const { dayDifference, dayPrice, guestTotal } = getBillingDetails({ checkIn, checkOut, bookingSpecialPricing, basePrice, total, guestServiceFee: serviceFee });
		const { formatMessage } = this.props.intl;

		return (
			<div>
				<div>
					<h3 className={cx(s.pricingTitle, 'rtlBookText')}><FormattedMessage {...messages.priceDetails} /></h3>
					<div className={cx(s.grid)}>
						<div className='paymentDetailsFlexLeft' style={{ fontWeight: 'bold' }}><FormattedMessage {...messages.serviceFee} /></div>
						<div className='paymentDetailsFlexRight' style={{ fontWeight: 'bold' }}>
							<CurrencyConverter amount={serviceFee} from={currency} />
						</div>
					</div>

					{cleaningPrice > 0 && <div className={cx(s.grid)}>
						<div className='paymentDetailsFlexLeft'><FormattedMessage {...messages.cleaningFee} /></div>
						<div className='paymentDetailsFlexRight'>
							<CurrencyConverter amount={cleaningPrice} from={currency} />
						</div>
						</div>
					}

					{tax > 0 && <div className={cx(s.grid, 'textWhite')}>
						<div className='paymentDetailsFlexLeft'><FormattedMessage {...messages.tax} /></div>
							<div className='paymentDetailsFlexRight'>
							<CurrencyConverter
								amount={tax}
								from={currency}
							/>
							</div>
						</div>
					}

					{discount > 0 && <div className={cx(s.grid, s.discountText)}>
						<div className='paymentDetailsFlexLeft' >{discountType}</div>
						<div className='paymentDetailsFlexRight'>
						-  <CurrencyConverter
							amount={discount}
							from={currency}
						/>
						</div>
					</div>
					}
					<div className={cx(s.grid)}>
						<div className='paymentDetailsFlexLeft'>Alojamiento ({dayDifference} {dayDifference > 1 ? formatMessage(messages.nights) : formatMessage(messages.nights)})</div>
						<div className='paymentDetailsFlexRight'>
							<CurrencyConverter amount={dayPrice} from={currency} />
						</div>
					</div>
					<div className={cx(s.grid, s.totalValue)}>
						<div className='paymentDetailsFlexLeft'>{formatMessage(messages.total)}</div>
						<div className='paymentDetailsFlexRight'>
							<CurrencyConverter amount={guestTotal} from={currency} />
						</div>
					</div>
					<div className={cx('comissionLabel')}>
						<FormattedMessage {...messages.comisionEslipinNote} />
					</div>
				</div>
			</div>
		);
	}
}

export default injectIntl(withStyles(s)(PaymentDetails));
